import React from 'react';
import { ToggleGroup } from '@base-ui/react/toggle-group';
import { Toggle } from '@base-ui/react/toggle';
import styled from '@emotion/styled';
import theme from '@/theme';

const ToggleGroupField = ({
  options,
  value,
  onValueChange,
  disabled,
}: {
  options: { value: string; label: string }[];
  value: string;
  onValueChange: (value: string) => void;
  disabled?: boolean;
}) => (
  <StyledGroup
    value={[value]}
    onValueChange={(values) => {
      const selected = values.find((v) => v !== value);
      if (selected) {
        onValueChange(selected);
      }
    }}
  >
    {options.map((option, index) => (
      <StyledToggle
        key={option.value}
        value={option.value}
        data-selected={option.value === value}
        disabled={disabled}
      >
        {option.label}
      </StyledToggle>
    ))}
  </StyledGroup>
);

export default ToggleGroupField;

const StyledGroup = styled(ToggleGroup)`
  display: flex;
  flex-direction: row;
`;

const StyledToggle = styled(Toggle)`
  padding: ${theme.sizes.scale[1]}px ${theme.sizes.scale[3]}px;
  margin-left: -1px; /* offset double borders between toggles */

  background-color: ${theme.colors.field};
  border-color: ${theme.colors.fieldBorder};
  border-width: ${theme.buttons.root.borderWidth};
  border-style: ${theme.buttons.root.borderStyle};
  cursor: pointer;

  font-weight: ${theme.text.body1a.fontWeight};
  font-size: ${theme.text.body1a.fontSize};
  line-height: ${theme.text.body1a.lineHeight};
  font-family: ${theme.text.body1a.fontFamily};

  &:first-of-type {
    margin-left: 0;
    border-top-left-radius: ${theme.radii.circle}px;
    border-bottom-left-radius: ${theme.radii.circle}px;
  }

  &:last-of-type {
    border-top-right-radius: ${theme.radii.circle}px;
    border-bottom-right-radius: ${theme.radii.circle}px;
  }

  &:hover {
    background-color: ${theme.colors.fieldHover};
  }

  &[data-selected='true'] {
    background-color: ${theme.colors.primary};
    border-color: ${theme.colors.primary};
    color: ${theme.colors.white};
  }
`;
